// extracted by mini-css-extract-plugin
export default {"postContent":"Forum_postContent__rVcK5","cardHover":"Forum_cardHover__GDl29"};